module.exports = __webpack_public_path__ + "static/img/gzz2.26b3dfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/gzz2.png
// module id = wg7D
// module chunks = 2